import React from "react";

const PipedriveIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_368_353)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.3334 1.66667H3.66669C2.56212 1.66667 1.66669 2.5621 1.66669 3.66667V16.3333C1.66669 17.4379 2.56212 18.3333 3.66669 18.3333H16.3334C17.4379 18.3333 18.3334 17.4379 18.3334 16.3333V3.66667C18.3334 2.5621 17.4379 1.66667 16.3334 1.66667Z",
  fill: "#203232"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.9 4.15C9.60001 4.15 8.84167 4.73333 8.48334 5.14167C8.44167 4.79167 8.20834 4.34167 7.31667 4.34167H5.35834V6.375H6.15834C6.29167 6.375 6.33334 6.41667 6.33334 6.55V15.85H8.65001V12.3583C8.65001 12.2667 8.65001 12.175 8.64167 12.1C9.00001 12.4333 9.69167 12.8917 10.775 12.8917C13.0417 12.8917 14.625 11.0917 14.625 8.525C14.6417 5.90833 13.1333 4.15 10.9 4.15ZM10.425 10.8667C9.17501 10.8667 8.60834 9.675 8.60834 8.56667C8.60834 6.825 9.55834 6.2 10.4583 6.2C11.55 6.2 12.2917 7.14167 12.2917 8.55C12.2833 10.1583 11.35 10.8667 10.425 10.8667Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_368_353"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16.6667,
  height: 16.6667,
  fill: "white",
  transform: "translate(1.66669 1.66667)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(PipedriveIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;